import { render, staticRenderFns } from "./productProcessing.vue?vue&type=template&id=6d840e6c&scoped=true"
import script from "./productProcessing.vue?vue&type=script&lang=js"
export * from "./productProcessing.vue?vue&type=script&lang=js"
import style0 from "./productProcessing.vue?vue&type=style&index=0&id=6d840e6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d840e6c",
  null
  
)

export default component.exports